export const TIME_RANGE_INCIDENT_REPORT: number = 1000 * 60 * 30; //30 minutes
